import { render } from "./App.vue?vue&type=template&id=62ffd786"
const script = {}

import exportComponent from "/home/tchelocabral/projetos/html/andrei/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__